<template>
  <div class="device-panel">
    <div v-for="item in devices" :key="item.name" class="device-card">
      <div class="device-left">
        <strong>{{ item.name }}</strong>
        <span>{{ item.status }}</span>
        <span>{{ item.value }}</span>
      </div>
      <div class="device-right">
        <span>{{ item.flowLabel }}</span>
        <strong>{{ item.flow }}</strong>
        <span>{{ item.time }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
const devices = [
  {
    name: "泵站A01",
    status: "运行中",
    value: "压力 0.28MPa",
    flowLabel: "流量",
    flow: "126m³/h",
    time: "2分钟前",
  },
  {
    name: "阀门B03",
    status: "已开启",
    value: "压力 0.24MPa",
    flowLabel: "流量",
    flow: "38m³/h",
    time: "1分钟前",
  },
  {
    name: "阀门A07",
    status: "待机待灌",
    value: "压力 0.18MPa",
    flowLabel: "流量",
    flow: "15m³/h",
    time: "5分钟前",
  },
];
</script>

<style lang="less" scoped>
.device-panel {
  width: 100%;
  height: 100%;
  min-height: 0;
  display: grid;
  grid-template-rows: repeat(3, 1fr);
  row-gap: 20px;
}

.device-card {
  position: relative;
  min-height: 0;
  display: grid;
  grid-template-columns: 1.04fr 0.96fr;
  column-gap: 12px;
  padding: 14px 20px;
  box-sizing: border-box;
  // background: linear-gradient(135deg, rgba(5, 87, 79, 0.78), rgba(0, 48, 49, 0.96));
  border: 1px solid rgba(105, 255, 244, 0.62);
  border-radius: 8px;
  box-shadow: inset 0 0 40px rgba(83, 255, 241, 0.18);

  &::before {
    content: "";
    position: absolute;
    top: -1px;
    left: 16px;
    width: 58px;
    height: 2px;
    background: #69fff3;
  }
}

.device-left,
.device-right {
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: left;
  color: #ffffff;
  font-size: 25px;
  line-height: 1.6;
  font-weight: bold;

  strong {
    font-size: 25px;
  }

  span {
    white-space: nowrap;
    
  }
}
</style>
